import { useServiceContextState } from "../store/GlobalContext";
import ICustomerCareUserService from "./CustomerCareUser/ICustomerCareUserService";
import IMachineService from "./Machine/IMachineService";

export const useMachineService: () => IMachineService = () =>
  useServiceContextState().machineService;
export const useCustomerCareUserService: () => ICustomerCareUserService = () =>
  useServiceContextState().customerCareUserService;
